export default __webpack_public_path__ + "42e3b8ffba91d94fec4b34677301688a.svg";